import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';

const mySelector = (state: RootState) => state.acapellas;

export const selectAcapellas = createSelector(
    mySelector,
    acapellas => acapellas?.acapellas,
);
export const selectSongs = createSelector(
    mySelector,
    acapellas => acapellas?.songs,
);

export const selectQuery = createSelector(
    mySelector,
    acapellas => acapellas?.query,
);


export const selectIsLoading = createSelector(
    mySelector,
    acapellas => acapellas?.isLoading,
);

export const selectSelectedAcapella = createSelector(
    mySelector,
    acapellas => acapellas?.selectedAcapella,
);
